import { render, staticRenderFns } from "./event-setting-form.vue?vue&type=template&id=740775a9"
import script from "./event-setting-form.vue?vue&type=script&lang=js"
export * from "./event-setting-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports